var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9875 8.5125L8 6.5L5.9875 4.4875L5.2875 5.1875L6.1 6H4V7H6.1L5.2875 7.8125L5.9875 8.5125ZM2 10C1.725 10 1.48967 9.90217 1.294 9.7065C1.098 9.5105 1 9.275 1 9V3C1 2.725 1.098 2.48967 1.294 2.294C1.48967 2.098 1.725 2 2 2H5L6 3H10C10.275 3 10.5105 3.098 10.7065 3.294C10.9022 3.48967 11 3.725 11 4V9C11 9.275 10.9022 9.5105 10.7065 9.7065C10.5105 9.90217 10.275 10 10 10H2Z",
    fill: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectArrow);
export default __webpack_public_path__ + "static/media/project-arrow.7dbd9274a8e2c5d54cc84f681eaaf24f.svg";
export { ForwardRef as ReactComponent };